module.exports = "/assets/data/86a43bf26aea078663302b5955f3a055-DE7.data.json";